import Link from '@/components/Link/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

const NotFound = () => {
  return (
    <Stack textAlign='center' gap={4}>
      <Typography component='h1' variant='h2' fontWeight='bold'>
        {t('page.not-found.title')}
      </Typography>
      <Typography variant='body2'>
        {t('page.not-found.description')}{' '}
        <Link variant='body2' href='/pay' color='inherit'>
          {t('page.not-found.start-page')}
        </Link>
        .
      </Typography>
    </Stack>
  );
};

export default NotFound;
